export default {
  resume: null,
  isLoadResumePreview: false,
  resumePreview: null,
  resumePreviewFilesImage: null,
  resumePreviewPDF: null,
};
